import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-brand-yellow bg-brand-navy pb-16" data-id="element-73" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-74" data-mp="32nuhkczrziw3">
        <p className="text-xs leading-snug text-brand-yellow" data-id="element-75" data-mp="32lrkxa44arie">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[11px] leading-snug text-white/70" data-id="element-76" data-mp="3uf0lz5mj42r6">
          {PRODUCT_NAME}™ es un producto educativo para niños de 5 a 12 años. Las
          actividades requieren supervisión de un adulto, especialmente cuando se
          utilizan tijeras, herramientas, componentes eléctricos o piezas
          pequeñas. Los experimentos y circuitos deben realizarse siguiendo las
          indicaciones de seguridad, utilizando materiales apropiados para la
          edad. Este material no sustituye la supervisión responsable ni las
          recomendaciones de seguridad de los fabricantes.
        </p>
        <p className="mt-1.5 text-xs text-white" data-id="element-77" data-mp="3l90lvqkngowm">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-gold transition-colors duration-150 ease-out hover:text-white" data-id="element-78" data-mp="3lbdc0r0ka5kr">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white" data-id="element-79" data-mp="3q8djn6d27gdz">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-80" data-mp="33xc3sjqnopv">
            Términos y Condiciones
          </a>
          <span className="text-brand-yellow/60" data-id="element-81" data-mp="huo4p2t5mru1">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-82" data-mp="cv1pwoxoh3j4">
            Política de Privacidad
          </a>
          <span className="text-brand-yellow/60" data-id="element-83" data-mp="msy4jqptqglz">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-84" data-mp="tv4om5kz9a6l">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}